import { Injectable } from '@angular/core'
import jspdf from 'jspdf'
import * as htmlToImage from 'html-to-image'

@Injectable({ providedIn: 'root' })
export class PdfGeneratorService {
    public async generate(htmlElement: HTMLElement, filename: string) {
        const image = await htmlToImage.toJpeg(htmlElement, {
            quality: 1,
            pixelRatio: 3,
            backgroundColor: 'white',
        })

        const orientation =
            htmlElement.offsetWidth >= htmlElement.offsetHeight ? 'landscape' : 'portrait'

        const pdf = new jspdf(orientation, 'px')

        pdf.internal.pageSize.width = htmlElement.offsetWidth
        pdf.internal.pageSize.height = htmlElement.offsetHeight

        pdf.addImage(image, 'JPEG', 0, 0, htmlElement.offsetWidth, htmlElement.offsetHeight)
        pdf.save(filename)
    }
}
